import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../LanguageContext';
import { WATER_SOLUTION_IMAGES as IMG, waterSolutionCopy as c, type Bi } from '../../data/waterSolution';
import { SourcesCard, InsightFloat, PropertyAlertCard, ConsumptionPhone } from './solution/SolutionCards';
import { SolutionLaptop } from './solution/SolutionLaptop';
import { SolutionStages } from './solution/SolutionStages';
const EASE = [0.23, 1, 0.32, 1] as const;
const PHOTO_MASK = {
  WebkitMaskImage: 'linear-gradient(to right, transparent 0%, rgba(0,0,0,0.5) 18%, #000 38%)',
  maskImage: 'linear-gradient(to right, transparent 0%, rgba(0,0,0,0.5) 18%, #000 38%)'
};
function MeterBubble({
  alt,
  size
}: {
  alt: string;
  size: string;
}) {
  return <div className={`${size} rounded-full overflow-hidden border-[5px] border-white shadow-[0_24px_44px_-24px_rgba(20,20,60,0.6)] shrink-0`} data-id="element-7714" data-mp="2jd9o6xtxtkr6">
      <img src={IMG.meter} alt={alt} className="w-full h-full object-cover object-[50%_45%] scale-[1.35]" data-id="element-7715" data-mp="3c1nltch46f27" />
    </div>;
}
export function WaterSolution() {
  const {
    lang
  } = useLanguage();
  const isFR = lang === 'FR';
  const pick = (v: Bi) => isFR ? v.fr : v.en;
  const reveal = {
    initial: {
      opacity: 0,
      y: 12
    },
    whileInView: {
      opacity: 1,
      y: 0
    },
    viewport: {
      once: true,
      margin: '-80px'
    }
  };
  const message = <>
      <p className="font-sans text-[13px] font-bold tracking-[0.3em] uppercase text-[#4F46E5]" data-id="element-7716" data-mp="398voo7mtmy8d">{pick(c.eyebrow)}</p>
      <h2 className="font-serif text-[2.8rem] sm:text-[3.8rem] 2xl:text-[4.8rem] leading-[1] tracking-tight mt-7" data-id="element-7717" data-mp="2vcqjao6l5y41">
        {c.navy.map(l => <span key={l.en} className="block text-[#0E1330]" data-id="element-7718" data-mp="2mahco9efuovx">{pick(l)}</span>)}
        <span className="block text-[#4F46E5]" data-id="element-7719" data-mp="2qbauqm5799gw">{pick(c.indigo)}</span>
      </h2>
      <p className="font-sans text-[17px] 2xl:text-[19px] leading-[1.6] text-[#4A5470] mt-7 max-w-[500px]" data-id="element-7720" data-mp="2qddva03zakzv">{pick(c.body)}</p>
    </>;
  return <div className="relative" data-id="element-7721" data-mp="oj6alwtxzggq">
      {/* Desktop */}
      <div className="hidden xl:block relative min-h-[740px]" data-id="element-7722" data-mp="1xh4p5k2tdws1">
        <div className="absolute inset-y-0 right-0 w-[76%]" aria-hidden="true" data-id="element-7723" data-mp="1xipi559hd7ns">
          <img src={IMG.background} alt="" className="w-full h-full object-cover" style={PHOTO_MASK} data-id="element-7724" data-mp="1sh04riyschwj" />
        </div>

        <div className="relative max-w-[1760px] mx-auto min-h-[740px]" data-id="element-7725" data-mp="1ogzri1nfacr2">
          <svg className="absolute inset-0 w-full h-full pointer-events-none" viewBox="0 0 1760 740" preserveAspectRatio="none" aria-hidden="true" data-id="element-7726" data-mp="1ji4x02g3ezr4">
            <path d="M615 290 L615 385" stroke="#FFFFFF" strokeWidth="2" strokeDasharray="3 5" data-id="element-7727" data-mp="2g9qjfzy2pfai" />
            <path d="M735 170 L850 170" stroke="#FFFFFF" strokeWidth="2" strokeDasharray="3 5" data-id="element-7728" data-mp="2c856keljh10b" />
            <path d="M995 210 L995 240" stroke="#FFFFFF" strokeWidth="2" strokeDasharray="3 5" data-id="element-7729" data-mp="27d7nsfygjda8" />
            <path d="M1118 104 L1232 104" stroke="#FFFFFF" strokeWidth="2" strokeDasharray="3 5" data-id="element-7730" data-mp="22e4wrzfbb7l9" />
            <path d="M800 460 L920 460" stroke="#FFFFFF" strokeWidth="2" strokeDasharray="3 5" data-id="element-7731" data-mp="2zxprh31968c8" />
          </svg>

          <motion.div {...reveal} transition={{
          duration: 0.3,
          delay: 0.1,
          ease: EASE
        }} className="absolute z-10 top-[56px] left-[27.5%] w-[250px]" data-id="element-7732" data-mp="2v3208wev6zty">
            <SourcesCard isFR={isFR} data-id="element-7733" data-mp="37g78dubgkpf8" />
          </motion.div>

          <div className="absolute z-10 top-[360px] left-[34.5%]" data-id="element-7734" data-mp="3ceh2e1lg5jz9">
            <span className="absolute -left-1.5 top-6 z-20 w-4 h-4 rounded-full bg-[#4F46E5] border-[3px] border-white" aria-hidden="true" data-id="element-7735" data-mp="3cgbohj8gfi4x" />
            <MeterBubble alt={pick(c.meterAlt)} size="w-[200px] h-[200px]" data-id="element-7736" data-mp="3lff7kn7mfxjf" />
          </div>

          <motion.div {...reveal} transition={{
          duration: 0.3,
          delay: 0.15,
          ease: EASE
        }} className="absolute z-20 top-[72px] left-[48.5%] w-[265px]" data-id="element-7737" data-mp="3qdqiz2dkeg3r">
            <InsightFloat isFR={isFR} data-id="element-7738" data-mp="3v5iapg8girvh" />
          </motion.div>

          <motion.div {...reveal} transition={{
          duration: 0.3,
          delay: 0.2,
          ease: EASE
        }} className="absolute z-20 top-[62px] left-[70%] w-[285px]" data-id="element-7739" data-mp="3yp05lrrxgea">
            <PropertyAlertCard isFR={isFR} data-id="element-7740" data-mp="7xxt4oezpa8s" />
          </motion.div>

          <motion.div {...reveal} transition={{
          duration: 0.3,
          delay: 0.05,
          ease: EASE
        }} className="absolute z-10 top-[155px] right-[1.5%] w-[35%] max-w-[620px]" data-id="element-7741" data-mp="czvi7za2mz9n">
            <SolutionLaptop isFR={isFR} data-id="element-7742" data-mp="3rgfl0vpmz3wa" />
          </motion.div>

          <motion.div {...reveal} transition={{
          duration: 0.3,
          delay: 0.1,
          ease: EASE
        }} className="absolute z-[15] top-[230px] left-[52%]" data-id="element-7743" data-mp="3re31wf856nhn">
            <ConsumptionPhone isFR={isFR} data-id="element-7744" data-mp="42lcvz1gm2qw" />
          </motion.div>

          <motion.div {...reveal} transition={{
          duration: 0.3,
          ease: EASE
        }} className="relative z-20 w-[29%] pl-6 2xl:pl-12 pt-24 pb-48" data-id="element-7745" data-mp="45fwjocnfjj9">
            {message}
          </motion.div>
        </div>

        <svg className="absolute bottom-0 left-0 w-full h-[150px] pointer-events-none z-[12]" viewBox="0 0 1440 150" preserveAspectRatio="none" aria-hidden="true" data-id="element-7746" data-mp="38jo42sxkh0ve">
          <path d="M0 150 L0 40 C 250 20, 480 90, 800 80 C 1100 70, 1300 40, 1440 10 L1440 150 Z" fill="#FFFFFF" data-id="element-7747" data-mp="3hgevgs16brjn" />
        </svg>
      </div>

      {/* Tablet / mobile */}
      <div className="xl:hidden px-6 max-w-[1100px] mx-auto" data-id="element-7748" data-mp="wsk4o271gdz9">
        <motion.div {...reveal} transition={{
        duration: 0.3,
        ease: EASE
      }} data-id="element-7749" data-mp="wu4whk1yxitf">
          {message}
        </motion.div>
        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-4 items-start" data-id="element-7750" data-mp="2jo8kb1u75jec">
          <SourcesCard isFR={isFR} data-id="element-7751" data-mp="2jm47tvi8fc2g" />
          <div className="flex items-center gap-4" data-id="element-7752" data-mp="25pha3qigghvh">
            <MeterBubble alt={pick(c.meterAlt)} size="w-[120px] h-[120px]" data-id="element-7753" data-mp="25r22pal7lqqp" />
            <div className="flex-1 min-w-0" data-id="element-7754" data-mp="2aobxl5rdaulx">
              <PropertyAlertCard isFR={isFR} data-id="element-7755" data-mp="2ydmugc5lk4us" />
            </div>
          </div>
        </div>
        <div className="mt-6 flex flex-col md:flex-row items-center md:items-start gap-6" data-id="element-7756" data-mp="32eyjafgncm1x">
          <ConsumptionPhone isFR={isFR} data-id="element-7757" data-mp="2onl4tfxliedr" />
          <div className="w-full md:flex-1" data-id="element-7758" data-mp="2omig9enqwo10">
            <InsightFloat isFR={isFR} data-id="element-7759" data-mp="2olqu0ug1g2ne" />
          </div>
        </div>
        <div className="mt-8" data-id="element-7760" data-mp="2tl3g3cz355ox">
          <SolutionLaptop isFR={isFR} data-id="element-7761" data-mp="2tkbixxpuazwj" />
        </div>
      </div>

      <div className="relative z-30 pt-14 xl:-mt-10" data-id="element-7762" data-mp="3hbh14jj964a0">
        <SolutionStages isFR={isFR} data-id="element-7763" data-mp="3m2pa5ego7nmn" />
      </div>
    </div>;
}